import React from 'react'
import { TextInput } from '@instructure/ui-text-input'

const FilterBySearch = (props) => {
  const { handleFilterSearch } = props

  return (
      <TextInput
        type="search"
        renderLabel="Search users:"
        placeholder="e.g. John Doe"
        screenReaderLabel="Search users"
        onChange={(_, value) => { handleFilterSearch(value) }}
        messages={[{ text: 'Start typing to search (minimum 3 characters)', type: 'hint' }]}
    />
  )
}

export default FilterBySearch;